<app-web-spotlight-template-list></app-web-spotlight-template-list>

<lib-button-input-portal [portalKey]="'displayableContentKey'">
  <lib-button-primary (buttonClicked)="viewModel.openCreateWebSpotlightTemplateModal()">
    Create Spotlight Template
  </lib-button-primary>
</lib-button-input-portal>
